import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Layout from '@/components/feature/Layout';
import Home from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import ComicDetailPage from '@/pages/comic/page';
import ChapterPage from '@/pages/chapter/page';
import AboutPage from '@/pages/about/page';

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/category/:slug',
        element: <CategoryPage />,
      },
      {
        path: '/comic/:id',
        element: <ComicDetailPage />,
      },
      {
        path: '/comic/:id/chapter/:chapterId',
        element: <ChapterPage />,
      },
      {
        path: '/about',
        element: <AboutPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;